import { default as MuiTableFooter } from '@mui/material/TableFooter';

/**
 * TableFooter contains the footer rows of a Table.
 *
 * Demos:
 *
 * - [Table — Footer](https://unify.workiva.org/components/table?tab=code#table-footer)
 *
 * API:
 *
 * - [TableFooter API](https://unify.workiva.org/components/table?tab=props#tablefooter)
 */
export const TableFooter = MuiTableFooter;
export {
  type TableFooterProps,
  tableFooterClasses,
} from '@mui/material/TableFooter';
